module.exports = __webpack_public_path__ + "img/area.ae126815.svg";